/**
 * Device pricing slice pieces — the per-device-category price rows shown on
 * the device pricing admin table.
 *
 * Contains:
 * - devicePricingInitialState — adapter state + table view substate
 * - addDevicePricingCases — load-list / delete extra reducers
 * - device pricing selectors
 */
import { createSelector } from '@reduxjs/toolkit';
import { normalize } from 'normalizr';

import { deleteDevicePricing, loadDevicePricing } from '@sophocles/features/billing/api';
import { DevicePricingSchema } from '@sophocles/features/billing/schema';
import { devicePricingAdapter } from '@sophocles/features/billing/slices/adapters';

export const devicePricingInitialState = devicePricingAdapter.getInitialState({
  view: {
    search: null,
    page: 0,
    order: 'asc',
    orderBy: 'id',
  },
});

export const addDevicePricingCases = builder => {
  builder
    .addCase(loadDevicePricing.fulfilled, (state, action) => {
      if (action.payload.results.length === 0) {
        return;
      }
      const normalized = normalize(action.payload.results, [DevicePricingSchema]);
      devicePricingAdapter.upsertMany(state.devicePricing, normalized.entities.devicePricing);
    })
    .addCase(deleteDevicePricing.fulfilled, (state, action) => {
      devicePricingAdapter.removeOne(state.devicePricing, action.payload);
    });
};

export const selectDevicePricingEntities = state => {
  return state.billing.devicePricing;
};
export const { selectById: selectDevicePricingById } = devicePricingAdapter.getSelectors(selectDevicePricingEntities);
export const selectDevicePricing = id => state => selectDevicePricingById(state, id);
export const selectDevicePricingViewProperties = createSelector(selectDevicePricingEntities, state => state.view);
